import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { IProps } from './models';

export const ResultsGroup: FC<IProps> = ({
    Title,
    children,
    classNames = {},
    fullWidth,
    hint,
    id,
    styles,
    title = 'Заголовок',
}) => {
    return (
        <div
            // ToDo: Артемьев Федор, поправить добавление стилей (попробовать &)
            className={cn({
                [styles.group]: !classNames.group,
                [classNames.group]: classNames.group,
                [styles.fullWidth]: fullWidth,
            })}
            id={id}
        >
            <Title hint={hint}>{title}</Title>

            <div className={styles.container}>{children}</div>
        </div>
    );
};
